const map = {
	"./de/tutorial_01.png": 8961,
	"./de/tutorial_02.png": 8794,
	"./de/tutorial_03.png": 6371,
	"./de/tutorial_04.png": 6204,
	"./en/tutorial_01.png": 1765,
	"./en/tutorial_02.png": 3934,
	"./en/tutorial_03.png": 3431,
	"./en/tutorial_04.png": 1288
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2613;